import OpacityField from './opacity-field';
export default OpacityField;
